export const CANCELLATION_TIMEOUT = 10000;
